import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Portador } from 'src/app/models/cad/portador/portador';
import { AbstractIdbaRequestModel } from 'src/app/shared/models/abstract-idba-request-model';
import { AbstractIdbaService } from 'src/app/shared/utils/abstract-idba-service.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PortadorService extends AbstractIdbaService {

  override model: Portador;
  constructor(http: HttpClient) { 
    super(http, new Portador());
    this.programName = "cad/portador/portador.p";
  }
}
